import axios from "axios";
import * as settings from "@/config/settings";

// TODO: resiliency patterns - https://github.com/softonic/axios-retry
// rather than increased timeouts

const axiosParams = {
  baseURL: settings.API_BASE_URL,
  timeout: settings.API_TIMEOUT,
  withCredentials: false
};

const client = axios.create(axiosParams);

export default {
  // low-level calls, may live in a separate service?
  getClient() {
    return client;
  },

  getDefaults() {
    return client.defaults;
  },

  getAuthorization() {
    const credentials = JSON.parse(
      localStorage.getItem(settings.LOCALSTORAGE.credentials)
    );
    if (credentials && credentials.access_token) {
      return `Bearer ${credentials.access_token}`;
    } else {
      return null;
    }
  },

  setAuthorization() {
    const authHeader = this.getAuthorization();
    if (authHeader) {
      client.defaults.headers.common["Authorization"] = authHeader;
    } else {
      delete client.defaults.headers.common["Authorization"];
    }
  },

  get(url) {
    this.setAuthorization();
    return client.get(url);
  },

  post(url, data) {
    this.setAuthorization();
    return client.post(url, data);
  },

  put(url, data) {
    this.setAuthorization();
    return client.put(url, data);
  },

  patch(url, data) {
    this.setAuthorization();
    return client.patch(url, data);
  },

  delete(url) {
    this.setAuthorization();
    return client.delete(url);
  }
};
